var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"flex flex-row border-b border-gainsboro px-6"},_vm._l((_vm.items),function(item,index){return _c('router-link',{key:index,attrs:{"to":{name: item.link}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('li',{class:[
        'link pb-3 mr-6 link text-trueBlue hover:text-black',
        isActive && 'active' ]},[_c('a',{staticClass:"pb-3",attrs:{"href":href},on:{"click":navigate}},[_vm._v(_vm._s(item.name))])])]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }